import styled from "@emotion/styled";

export const Heading = styled.h1<{ isLight: boolean }>`
    margin: 0;
    font-family: Custora;
    font-weight: 300;
    font-style: Light;
    font-size: 32px;
    leading-trim: NONE;
    line-height: 42px;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;

    color: #e9ecf5;
`;

export const SubHeading = styled.div`
    font-family: Inter;
    font-weight: 300;
    font-style: Light;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 150%;
    letter-spacing: 0px;
    text-align: center;
    vertical-align: middle;
    color: #b7bdcb;
`;
